import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ColDef, ColumnApi, GetRowIdParams, GridApi, GridOptions } from 'ag-grid-community';
import { Observable, Subscription } from 'rxjs';
import { ISubcontractor, SubcontractorsService } from 'src/app/contracts/subcontractors.service';
import { ITrade, TradesService } from 'src/app/contracts/trades.service';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/shared-components/confirm-dialog/confirm-dialog.component';
import { AgGridSettings, UserSettingsService } from 'src/app/user-settings/user-settings.service';

@Component({
  selector: 'app-subcontractors',
  templateUrl: './subcontractors.component.html',
  styleUrls: ['./subcontractors.component.scss']
})
export class SubcontractorsComponent implements OnInit {

  subscriptions: Subscription = new Subscription();
  reps: ISubcontractor[] = [];
  selectedSubcontractor: ISubcontractor | null = null;
  trades: Observable<ITrade[]> | undefined;

  gridApi: GridApi | undefined;
  gridColumnApi: ColumnApi | undefined;
  gridOptions: GridOptions = {};
  agGridTheme = 'ag-theme-balham';
  gridActivated = false;
  defaultColDef: any;
  cols: ColDef[] = [];

  filterParams = {
    comparator: (filterLocalDateAtMidnight: any, cellValue: any) => {
      if (cellValue === null) return -1;
      const cellDate = new Date(cellValue);
      if (filterLocalDateAtMidnight.getTime() == cellDate.getTime()) { return 0 }
      if (cellDate < filterLocalDateAtMidnight) { return -1; }
      if (cellDate > filterLocalDateAtMidnight) { return 1; }
      return -1
    },
    browserDatePicker: true,
    buttons: ['reset', 'apply']
  };


  form = this.fb.group({
    Id: [0],
    ContractorName: ['', Validators.required],
    Trade: [''],
  });


  constructor(private repsService: SubcontractorsService, private tradesService: TradesService, private fb: FormBuilder, private userSettings: UserSettingsService,private dialog: MatDialog) {
    this.subscriptions.add(this.userSettings.agGridSettings.subscribe(data => {
      this.initGrid(data);
    }));
    this.trades = this.tradesService.trades;
  }

  ngOnInit(): void {
    this.repsService.subcontractors.subscribe(data => this.reps = data);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }


  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onSelectionChanged() {
    const selectedRows = this.gridApi?.getSelectedRows() ?? [];
    if (selectedRows?.length > 0) {
      const selectedSubcontractor = selectedRows[0] as ISubcontractor;
      this.resetForm();
      this.selectedSubcontractor = { ...selectedSubcontractor };
      this.form.setValue(this.selectedSubcontractor);
    }
  }

  clearFilters() {
    this.gridOptions.api?.setFilterModel(null);
    this.gridApi?.onFilterChanged();
  }

  initGrid(data: AgGridSettings) {
    this.gridActivated = false;
    const { theme, ...gridOptions } = data;
    this.gridOptions = gridOptions;
    this.agGridTheme = theme;
    this.gridOptions.getRowId = (params: GetRowIdParams) => params.data.Id;

    this.defaultColDef = {
      filter: 'agTextColumnFilter',
      resizable: true,
      sortable: true,
      cellStyle: { 'line-height': `${(data.rowHeight ?? 20) - 4}px` },
      floatingFilter: true,
      filterParams: {
        debounceMs: 1
      },
    };

    this.cols = [
      { field: 'ContractorName', headerName: 'Name', flex: 1 },
      { field: 'Trade', headerName: 'Trade', flex: 1 },
    ];
    setTimeout(() => { this.gridActivated = true; }, 1);
  }

  resetForm() {
    this.selectedSubcontractor = null;
    this.form = this.fb.group({
      Id: [0],
      ContractorName: ['', Validators.required],
      Trade: [''],
    });
  }


  newCrew() {
    this.selectedSubcontractor = null;
    this.resetForm();
    this.gridApi?.deselectAll();
  }

  saveCrew() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }

    const crew = this.form.value as ISubcontractor;
    this.repsService.saveSubcontractor(crew).subscribe(data => {
      setTimeout(() => {
        this.gridApi?.forEachNode(node => node.data.Id === data.Id ? node.setSelected(true, true) : null);
      }, 50);
    });

    this.resetForm();
  }

  deleteCrew() {
    if (this.selectedSubcontractor === null) { return; }

    const message = `Are you sure you want to delete subcontractor: '${this.selectedSubcontractor.ContractorName}' ?`;
    const dialogData = new ConfirmDialogModel("Confirm Delete", message);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        if (this.selectedSubcontractor !== null) {
          this.repsService.deleteSubcontractor(this.selectedSubcontractor).subscribe(data => this.resetForm());
        }
      }
    });
  }
}
